import { isNil, pick } from '../utils/fp';
import { fromStateToSearch } from '../utils/router';

// A navigation without payload resets the location state: only what does not
// belong to a dataflow survives (see the app duck).
const INVARIANT_KEYS = ['locale', 'hasAccessibility', 'tenant'];

// The location state a navigation lands on: the payload merged into the
// current one, or the invariants alone when there is no payload.
export const getNextLocationState = (locationState, payload) =>
  isNil(payload) ? pick(INVARIANT_KEYS, locationState) : { ...locationState, ...payload };

// The search is a pure function of the location state: the layout is serialised
// as it stands, and compacted on read against the dimensions the dataflow turns
// out to expose (rules2.getTableLayoutIds). Compacting it here instead made the
// url depend on the fetch lifecycle -- the very same layout was serialised away
// while the data was not in yet, and restored once it was.
export const getNextSearch = locationState => fromStateToSearch(locationState);
